export const openGladlyChat = () => {
  if (window.Gladly) {
    window.Gladly.show();
  }
};

export const onGladlyReady = (callback) => {
  if (window.__gladlyReady) {
    callback();
  } else {
    window.addEventListener('gladly:ready', callback, { once: true });
  }
};

export const identifyGladlyUser = ({ email, name }) => {
  if (!email || !window.Gladly) {
    return;
  }

  try {
    // Gladly persists the identified user across page reloads, so a fresh
    // load can already have this (or another) user set — check first
    // instead of assuming setUser() is safe to call blind.
    const currentUser = window.Gladly.getUser();
    if (currentUser?.identity === email) {
      return;
    }
    if (currentUser) {
      window.Gladly.clearUser();
    }
    window.Gladly.setUser({ email, name });
  } catch (err) {
    console.error('Gladly setUser failed', err);
  }
};

export const clearGladlyUser = () => {
  if (!window.Gladly) {
    return;
  }

  try {
    if (window.Gladly.getUser()) {
      window.Gladly.clearUser();
    }
  } catch (err) {
    console.error('Gladly clearUser failed', err);
  }
};
